import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from './config.service';
import {InvitationDetails} from '../model/invitation-details.model';
import {Invitation} from '../model/invitation.model';
import {InvitedUser} from '../model/invited-user.model';
import {Login} from '../model/login.model';

@Injectable()
export class InvitationService {
    constructor(private httpClient: HttpClient) {
    }

    async getMinimalInvitationDetails(inviteId: string): Promise<InvitationDetails> {
        // Maybe the endpoint name isn't so right!
        const url = ConfigService.getInvitationServiceBaseUrl() + `/invitation/consentDetails?invitationId=${inviteId}`;
        return this.httpClient.get<InvitationDetails>(url).toPromise();
    }

    async verifyPan(inviteId: string, name?: string): Promise<string> {
        const url = ConfigService.getInvitationServiceBaseUrl() + `/invitation/verify-pan`;
        let httpParams = new HttpParams().append('invitationId', inviteId);

        if (name) {
            httpParams = httpParams.append('name', name);
        }

        const responseBody = await this.httpClient.get<{ phoneVerificationRequestToken: string }>(url, {params: httpParams})
            .toPromise();
        return responseBody.phoneVerificationRequestToken;
    }

    async requestForPhoneVerification(token: string, inviteId: string): Promise<string> {
        const url = ConfigService.getInvitationServiceBaseUrl() + `/invitation/verify-phone?token=${token}&inviteId=${inviteId}`;
        try {
            const responseBody = await this.httpClient.get<{ phoneVerificationToken: string }>(url).toPromise();
            return responseBody.phoneVerificationToken;
        } catch (e) {
            return null;
        }
    }

    async updateUserEmail(inviteId: string, userId: string): Promise<string> {
        const url = ConfigService.getInvitationServiceBaseUrl() + `/invitation/${inviteId}/${userId}/update-email`;
        try {
            return this.httpClient.put<string>(url, {}).toPromise();
        } catch (e) {
            return null;
        }
    }

    async verifyAndGetInvitation(inviteId: string): Promise<Invitation> {
        const url = ConfigService.getInvitationServiceBaseUrl() + `/invitationuser/${inviteId}`;
        return await this.httpClient.post<Invitation>(url, null).toPromise();
    }

    async getUserByInviteId(inviteId: string): Promise<InvitedUser> {
        const url = ConfigService.getInvitationServiceBaseUrl() + `/invitation/get-user?invitationId=${inviteId}`;
        try {
            return await this.httpClient.get<InvitedUser>(url).toPromise();
        } catch (e) {
            return null;
        }
    }

    async updateStatusByInviteId(inviteId: string, status: string): Promise<void> {
        try {
            const url = ConfigService.getInvitationServiceBaseUrl() + `/invitation/${inviteId}/update-status?status=${status}`;
            await this.httpClient.put<void>(url, null).toPromise();
        } catch (e) {
            console.log(e);
        }
    }
}
